import { httpClient } from '../lib/axios';

export const bundle_api = {
  get: async () => {
    try {
      const res = await httpClient.get('bundle/');
      return res.data;
    } catch (err) {
      return err;
    }
  },

  add: async payload => {
    try {
      const res = await httpClient.post('bundle/', payload);
      return res.data;
    } catch (err) {
      return err;
    }
  },

  edit: async (id,payload) => {
    try {
      const res = await httpClient.put(`bundle/${id}/`, payload);
      return res.data;
    } catch (err) {
      return err;
    }
  },

  delete: async id => {
    try {
      const res = await httpClient.delete(`bundle/?id=${id}`);
      return res.data;
    } catch (err) {
      return err;
    }
  },
};
